import { Api_url } from "../../common/api_url"
import { API_XANO_AUTH_BASE_URL, API_XANO_BASE_URL, API_XANO_SEARCH_BASE_URL, API_XANO_SYNC_GOOGLE_CONTACT } from "../../config/api_config"
import { axiosAuth, axiosNoAuth } from "../../config/axiosInstances"
import { EDIT_USER_BIO, SET_MOBILE_NUMBER, SET_AVAILABLE_COINS, SET_AVAILABLE_COINS_COLLEGE, SHAUN_ELLIS_TEST, NPS_TEST, SET_WALKTHROUGH_DATA, SET_PROFILE_DETAILS, GET_ENROLLED_SKILLS } from "./types"

export function editUserNumber(user_id, phone_number, verified) {
    return async function (dispatch) {
        try {
            const response = axiosAuth.post(API_XANO_SEARCH_BASE_URL + Api_url.EditMobileNumber, {
                user_id,
                phone_number,
                verified
            })

            dispatch({ type: SET_MOBILE_NUMBER, payload: { verified, phone_number } })
        } catch (err) {
            console.log(err)
        }
    }
}

export function editUserBio(bio, user_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.EditUserBio, {
                user_id,
                bio
            })

            dispatch({ type: EDIT_USER_BIO, payload: bio })
            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function editUserName(new_name, user_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.EditUserName, {
                user_id,
                new_name
            })

            dispatch({ type: SET_PROFILE_DETAILS, payload: response.data })
            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function editUserprofileImage(formData, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.EditUserProfileImage, formData,
                {
                    "Content-Type": "form-data"
                })

            dispatch({ type: SET_PROFILE_DETAILS, payload: response.data })
            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function getUserEnrolledSkills(user_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetEnrolledSkills, {
                params: {
                    user_id
                }
            })
            dispatch({type: GET_ENROLLED_SKILLS, payload: response.data})
            successCallback && successCallback(response.data)
        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function getUserEnrolledMSkills(user_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetUserEnrolledMSkills, {
                params: {
                    user_id
                }
            })

            successCallback && successCallback(response.data)
        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function refreshUserCoins(user_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetUserCoins, {
                params: {
                    user_id
                }
            })
            dispatch({ type: SET_AVAILABLE_COINS, payload: response.data['available-coins'] })

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function addUserActivity(user_id, activity_type, activity_details = "", is_school_credit, skill_slug = null, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            if (user_id === 0 || user_id === null || user_id === undefined) {
                successCallback && successCallback({});
            }
            else {
                const response = await axiosAuth.post(API_XANO_AUTH_BASE_URL + Api_url.AddUserActivity, {
                    user_id,
                    activity_type: activity_type.type,
                    activity_details,
                    is_school_credit,
                    skill_slug
                })

                if (response?.data?.id) {
                    if (response?.data?.college_referral_id) {
                        dispatch({ type: SET_AVAILABLE_COINS_COLLEGE, payload: response?.data?.coin_quota?.current_coins })
                    }
                    else {
                        dispatch({ type: SET_AVAILABLE_COINS, payload: response.data['available-coins'] })
                    }
                }

                successCallback && successCallback(response.data)
            }

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function getUserLearnings(user_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosAuth.get(
                API_XANO_BASE_URL + Api_url.GetUserLearnings,
                {
                    params: {
                        user_id,
                    },
                }
            );

            successCallback && successCallback(response.data);
        } catch (err) {
            console.log(err);
            errorCallback && errorCallback(err);
        }
    };
}

export function getUserReferrals(user_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetUserReferrals, {
                params: {
                    user_id
                }
            })

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function addShaunEllisResponse(option, user_id, successCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.ShaunEllisTest, {
                user_id,
                response: option
            })

            await dispatch({ type: SHAUN_ELLIS_TEST, payload: response.data })
            successCallback()

        } catch (err) {
            console.log(err)
        }
    }
}

export function addNPSResponse(option, user_id, successCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.NPSTest, {
                user_id,
                response: option
            })

            await dispatch({ type: NPS_TEST, payload: response.data })
            successCallback()

        } catch (err) {
            console.log(err)
        }
    }
}

export function editWalkthrough(user_id, walkthrough, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.EditWalkthrough, {
                user_id,
                walkthrough
            })

            dispatch({ type: SET_WALKTHROUGH_DATA, payload: response.data.walkthrough })

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function syncGoogleContacts(code, redirect_uri, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.get(API_XANO_SYNC_GOOGLE_CONTACT + Api_url.SyncGoogleContact, {
                params: {
                    code,
                    redirect_uri
                }
            })

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function createLinkedinPost(code, redirect_uri, post_desc, post_comment, image_url, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.post(API_XANO_BASE_URL + Api_url.CreateLinkedinPost, {
                code,
                redirect_uri,
                post_desc,
                image_url,
                post_comment
            })

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function addSocialActivity(user_id, activity_type, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.AddSocialActivity, {
                user_id,
                activity_type: activity_type.type,
            })

            if (response?.data['available-coins']) {
                if (response?.data?.college_referral_id) {
                    dispatch({ type: SET_AVAILABLE_COINS_COLLEGE, payload: response?.data?.coin_quota?.current_coins })
                }
                else {
                    dispatch({ type: SET_AVAILABLE_COINS, payload: response.data['available-coins'] })
                }
            }

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}


export function deleteUser(deletion_reason, successCallback , errorCallback){
    return async function(dispatch){
        try{
            const response = await axiosAuth.delete(API_XANO_BASE_URL + Api_url?.DeleteUser,{
                params:{
                    deletion_reason
                }
            })

            successCallback && successCallback(response.data);

        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}